export const daySec = 86400;